import * as React from 'react';
import Cached from 'material-ui/svg-icons/action/cached';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';

import { TasksForm } from '@modules/tasks/TasksForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { ActionBarTasks } from '@modules/tasks/TasksGridButtons';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const tasksUrl = '/metropolis/api/ts/tasks';
export const tasksLabel = 'Úkoly';
export const tasksPath = '/tasks';
export const tasksGridName = 'module-tasks';
export const TasksGrid = compose(
  withRouter,
  setDisplayName('TasksGrid'),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: tasksLabel }]),
  withColumns(Agenda.TASKS),
  withProps(({ history, columns }) => ({
    name: tasksGridName,
    url: tasksUrl,
    Form: TasksForm,
    dialog: false,
    gridProps: {
      ActionBar: ActionBarTasks,
      history,
      deleteFiltersTooltip: 'Reset filtrů',
      deleteFiltersIcon: <Cached />,
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: false,
      locale: 'cz',
      adding: true,
      pageSize: 50,
      version: 2
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/tasks/TasksGrid.tsx